import { CreateSurveyAnswerResponseDTO } from '@/core/dto/psychosocial-report';

export class CreateSurveyAnswerMapper {
	constructor(private readonly data: CreateSurveyAnswerResponseDTO) {}

	public toDomain() {
		return {
			status: this.data.status,
			message: this.data.message
		};
	}
}
